function checkIsNotReferrer() {
  return window != window.parent;
}

export { checkIsNotReferrer };
